import routerOptions0 from "/opt/render/project/src/node_modules/.pnpm/nuxt@4.1.3_@netlify+blobs@9.1.1_@parcel+watcher@2.5.1_@types+node@22.15.21_@vue+compile_f6c70ea1eb533eaec0fe8a1184c3379f/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/opt/render/project/src/apps/refresh/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}